import React, { FC } from 'react';

import Skeleton, {
  SKELETON_SHAPES,
  SKELETON_SIZES,
  SKELETON_WIDTHS
} from '@buyside/components/presentation/Skeleton/skeleton';

import styles from './rankCardStyles.scss';

const RankCardLoading: FC<{ times?: number }> = ({ times = 3 }) => (
  <>
    {[...Array(times)].map((_e, i) => (
      <div className={styles.rankCardContainer} key={`rank-card-loading-${i}`}>
        <div className={styles.rankCardStart}>
          <div className={styles.rankCardRank}>
            <span>
              <Skeleton size={SKELETON_SIZES.LARGE} width={SKELETON_WIDTHS.TINY} />
            </span>
            <span style={{ marginTop: 6 }}>
              <Skeleton size={SKELETON_SIZES.SMALL} width={SKELETON_WIDTHS.SMALL} />
            </span>
          </div>
        </div>
        <div className={styles.rankCardMiddle}>
          <div className={styles.userDisplay}>
            <div className={styles.userDisplayStart}>
              <Skeleton shape={SKELETON_SHAPES.CIRCLE} containerHeight={70} containerWidth={70} />
            </div>
            <div>
              <div>
                <Skeleton size={SKELETON_SIZES.LARGE} width={SKELETON_WIDTHS.MEDIUM} />
              </div>
              <div>
                <Skeleton size={SKELETON_SIZES.SMALL} width={SKELETON_WIDTHS.LARGE} />
              </div>
              <div>
                <Skeleton size={SKELETON_SIZES.SMALL} width={SKELETON_WIDTHS.SMALL} />
              </div>
              <div className={styles.userDisplayActions}>
                <Skeleton size={SKELETON_SIZES.MEDIUM} width={SKELETON_WIDTHS.SMALL} />
                <Skeleton size={SKELETON_SIZES.MEDIUM} width={SKELETON_WIDTHS.SMALL} />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.rankCardEnd}>
          <div className={styles.topIdeasListHeader}>
            <label>
              <Skeleton size={SKELETON_SIZES.SMALL} width={SKELETON_WIDTHS.SMALL} />
            </label>
            <label>
              <Skeleton size={SKELETON_SIZES.SMALL} width={SKELETON_WIDTHS.SMALL} />
            </label>
          </div>
          <div className={styles.ideasList}>
            <Skeleton containerHeight={44} containerWidth={100} />
            <Skeleton containerHeight={44} containerWidth={100} />
            <Skeleton containerHeight={44} containerWidth={100} />
          </div>
          <div className={styles.latestIdeaAndBadges}>
            <div>
              <label>
                <Skeleton size={SKELETON_SIZES.SMALL} width={SKELETON_WIDTHS.SMALL} />
              </label>
              <div className={styles.ideasList}>
                <Skeleton containerHeight={44} containerWidth={100} />
              </div>
            </div>
            <div>
              <label>
                <Skeleton size={SKELETON_SIZES.SMALL} width={SKELETON_WIDTHS.TINY} />
              </label>
              <div className={styles.badgesList}>
                <Skeleton shape={SKELETON_SHAPES.CIRCLE} containerHeight={24} containerWidth={24} />
                <Skeleton shape={SKELETON_SHAPES.CIRCLE} containerHeight={24} containerWidth={24} />
                <Skeleton shape={SKELETON_SHAPES.CIRCLE} containerHeight={24} containerWidth={24} />
              </div>
            </div>
          </div>
        </div>
      </div>
    ))}
  </>
);

export default RankCardLoading;
